import ModalImport from '../../../../../Features/Modal/ModalImport';
import {importExcel} from '../../service';
import {ProModalProps} from '../../../../../Components/ProModal';

export function ImportExcelModal({onOk, ...props}: ProModalProps) {
    async function onUpload(file: File) {
        await importExcel(file);
        onOk?.();
    }

    return (
        <ModalImport
            {...props}
            title="Excel导入菜单数据"
            onUpload={onUpload}
            templateUrl={require('./【导入模板】Excel 导入菜单数据 V0.1.xlsx')}
            templateName="菜单数据导入模板"
            restSteps={['2. 在导入模板补充好数据后上传文件']}
        />
    );
}
